
import { Avatar, Box, Button,Center,colorMode, useColorMode, Wrap, WrapItem } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { WiDaySunny, WiMoonWaningCrescent2 } from 'react-icons/wi';
import './App.css';
import Navbar from './Components/Navbar';
import AllRoutes from './Pages/Allroutes';
import ProjectsP from './Pages/ProjectPage';
import RotateLoader from "react-spinners/RotateLoader";

// const override: CSSProperties = {
//   display: "block",
//   margin: "0 auto",
  

  
// };
function App() {
   const [loading,setLoading]=useState(false)
   const { colorMode, toggleColorMode } = useColorMode()
    const isDark = colorMode ==="dark"
   useEffect(()=>{
    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    },3000)
   },[])
  return (
    <div className="App" >
      {
        loading  ? <Center>
         <Box  marginTop={["250px","300px","300px","400px"]}>
          <RotateLoader
        color={isDark ? "white":"black"}
        loading={loading}
        // cssOverride={override}
        size={40}
        
      />
        
        </Box> 

        </Center>:  <> <Navbar/>
      <AllRoutes/></>
      
      }
     
      
      
    </div>
  );
}

export default App;
